const companies = {
  status: {
    active: 'Ativa',
    inactive: 'Inativa',
    blocked: 'Bloqueada',
    freeTrial: 'Teste Grátis',
    trialActive: 'Em teste grátis',
    trialEndsAt: 'Teste grátis termina em {{date}}',
    blockReason: 'Motivo do bloqueio: {{reason}}',
    inactivationReason: 'Motivo da inativação: {{reason}}',
  },
  plan: {
    monthly: 'Mensal',
    trimesterly: 'Trimestral',
    semesterly: 'Semestral',
    annual: 'Anual',
  },
  payment: {
    asaas: 'Asaas',
    manual: 'Manual',
    other: 'Outro',
  },
  list: {
    title: 'Empresas',
    description: 'Gerencie as empresas cadastradas no sistema, planos e acessos.',
    mobileDescription: 'Gerencie as empresas do sistema.',
    totalLabel: 'empresa(s)',
    create: 'Nova Empresa',
    searchMobilePlaceholder: 'Buscar empresa...',
    searchDesktopPlaceholder: 'Buscar por nome, responsável, CPF/CNPJ...',
    filtersTitle: 'Filtros',
    filtersDescription: 'Filtre as empresas por status, cidade e estado',
    emptyInitialTitle: 'Nenhuma empresa cadastrada',
    emptySearchTitle: 'Nenhum resultado encontrado',
    emptyInitialDescription: 'Comece cadastrando a primeira empresa.',
    emptySearchDescription:
      'Nenhuma empresa corresponde aos critérios de busca. Tente ajustar os filtros.',
    mobileEmptyMessage: 'Nenhuma empresa encontrada.',
    cityLabel: 'Cidade',
    documentLabel: 'CPF/CNPJ',
    notesTitle: 'Observação',
    notesAriaLabel: 'Ver observação',
  },
  filters: {
    status: 'Status',
    state: 'Estado',
    city: 'Cidade',
    citySearchPlaceholder: 'Buscar cidade...',
    cityEmptyMessage: 'Nenhuma cidade encontrada.',
  },
  table: {
    company: 'Empresa',
    document: 'CPF/CNPJ',
    city: 'Cidade',
    status: 'Status',
    actions: 'Ações',
  },
  form: {
    createTitle: 'Nova Empresa',
    editTitle: 'Editar Empresa',
    createDescription: 'Preencha os dados para cadastrar uma nova empresa.',
    editDescription: 'Atualize as informações da empresa.',
    loading: 'Carregando informações...',
    loadError: 'Não foi possível carregar os dados da empresa.',
    retry: 'Tentar novamente',
    fantasyName: 'Nome fantasia',
    origin: 'Origem',
    responsibleName: 'Nome do responsável',
    whatsapp: 'WhatsApp',
    email: 'E-mail',
    phone: 'Telefone',
    corporateName: 'Razão social',
    document: 'CPF/CNPJ',
    notes: 'Observações',
    planPrice: 'Valor do plano',
    periodicity: 'Periodicidade',
    paymentMethod: 'Método de pagamento',
    trialEndsAt: 'Fim do teste grátis',
    city: 'Cidade',
    cityEmptyMessage: 'Nenhuma cidade encontrada.',
    cep: 'CEP',
    street: 'Rua',
    number: 'Número',
    district: 'Bairro',
    complement: 'Complemento',
    cancel: 'Cancelar',
    createSubmit: 'Cadastrar empresa',
    editSubmit: 'Salvar alterações',
    creating: 'Cadastrando...',
    saving: 'Salvando...',
    cepNotFound: 'CEP não encontrado',
  },
  profile: {
    fallbackTitle: 'Perfil da empresa',
    loadErrorTitle: 'Perfil da empresa',
    loadErrorDescription: 'Não foi possível carregar os dados da empresa selecionada.',
    notFoundTitle: 'Empresa não encontrada',
    notFoundDescription: 'Verifique se a empresa ainda existe ou tente novamente em instantes.',
    description: 'Centralize os dados da empresa, funcionários e histórico operacional.',
    mobileDescription: 'Dados e suporte da empresa.',
    employeesTotalLabel: 'funcionário(s)',
    employeeSearchPlaceholder: 'Buscar funcionário por nome ou e-mail...',
    employeesEmptyTitle: 'Nenhum funcionário cadastrado',
    employeesEmptyDescription: 'A empresa ainda não possui funcionários vinculados.',
    employeesTitle: 'Funcionários',
    historyTitle: 'Histórico',
    operationalStatus: 'Status operacional',
    originAndLocation: 'Origem e localização',
    responsible: 'Responsável',
    currentPlan: 'Plano atual',
    fantasyName: 'Nome fantasia',
    corporateName: 'Razão social',
    document: 'CPF/CNPJ',
    origin: 'Origem',
    createdAt: 'Criado em',
    hiredAt: 'Contratado em',
    email: 'E-mail',
    phone: 'Telefone',
    planPrice: 'Valor do plano',
    periodicity: 'Periodicidade',
    paymentMethod: 'Método de pagamento',
    trialEndsAt: 'Fim do teste grátis',
    asaasCustomer: 'Cliente Asaas',
    asaasSubscription: 'Assinatura Asaas',
    blockReason: 'Motivo do bloqueio',
    inactivationReason: 'Motivo da inativação',
    address: 'Endereço',
    complement: 'Complemento',
    district: 'Bairro',
    cep: 'CEP',
    city: 'Cidade',
    historyEmptyTitle: 'Sem histórico registrado',
    historyEmptyDescription: 'Ainda não há eventos registrados para esta empresa.',
    historyBy: 'por',
    copyActivationLinkUnavailable: 'Este funcionário não possui link de ativação disponível',
    copyActivationLinkSuccess: 'Link de ativação copiado com sucesso',
    copyActivationLinkError: 'Não foi possível copiar o link de ativação',
  },
  employees: {
    employee: 'Funcionário',
    status: 'Status',
    account: 'Conta',
    activation: 'Ativação',
    active: 'Ativo',
    inactive: 'Inativo',
    activated: 'Ativada',
    pending: 'Pendente',
    copyActivationLink: 'Copiar link de ativação',
  },
  actions: {
    activate: 'Reativar',
    inactivate: 'Inativar',
    block: 'Bloquear',
    unblock: 'Desbloquear',
    extendTrial: 'Estender teste',
    inactivateTitle: 'Inativar empresa',
    inactivateDescription:
      'Tem certeza que deseja inativar a empresa "{{name}}"? A empresa perderá o acesso ao sistema.',
    inactivating: 'Inativando...',
    inactivationReason: 'Motivo da inativação',
    reactivateTitle: 'Reativar empresa',
    reactivateDescription:
      'Tem certeza que deseja reativar a empresa "{{name}}"? A empresa voltará a ter acesso ao sistema.',
    reactivating: 'Reativando...',
    blockTitle: 'Bloquear empresa',
    blockDescription:
      'Tem certeza que deseja bloquear a empresa "{{name}}"? A empresa ficará impedida de acessar o sistema.',
    blocking: 'Bloqueando...',
    blockReason: 'Motivo do bloqueio',
    unblockTitle: 'Desbloquear empresa',
    unblockDescription:
      'Tem certeza que deseja desbloquear a empresa "{{name}}"? A empresa voltará a ter acesso ao sistema.',
    unblocking: 'Desbloqueando...',
    reasonPlaceholder: 'Informe o motivo...',
    cancel: 'Cancelar',
  },
  toast: {
    createSuccess: 'Empresa cadastrada com sucesso',
    createError: 'Ocorreu um erro ao cadastrar a empresa',
    updateSuccess: 'Empresa atualizada com sucesso',
    updateError: 'Ocorreu um erro ao atualizar a empresa',
    inactivateSuccess: 'Empresa inativada com sucesso',
    inactivateError: 'Ocorreu um erro ao inativar a empresa',
    reactivateSuccess: 'Empresa reativada com sucesso',
    reactivateError: 'Ocorreu um erro ao reativar a empresa',
    blockSuccess: 'Empresa bloqueada com sucesso',
    blockError: 'Ocorreu um erro ao bloquear a empresa',
    unblockSuccess: 'Empresa desbloqueada com sucesso',
    unblockError: 'Ocorreu um erro ao desbloquear a empresa',
    extendTrialSuccess: 'Período de teste estendido com sucesso',
    extendTrialError: 'Ocorreu um erro ao estender o período de teste',
  },
}

export default companies
